import React, { useEffect } from 'react'

// next components

// third party components
import Lottie from 'lottie-react'

// custom functions

// images
import SuccessIcon from 'assets/lottery/success.json'
import SuccessLightIcon from 'assets/lottery/success-light.json'
import FailureIcon from 'assets/lottery/failure.json'

// styles
import styles from './index.module.scss'
import { useSelector } from 'react-redux'

const AlertMobile = props => {
  const { open, close, data } = props
  const lightDarkMode = useSelector(state => (state as any).lightMode)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        close()
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    open && (
      <div className={styles.bgView}>
        {data.map((item, index) => (
          <div key={index}>
            <div className="flex gap-[10px] items-cetner">
              <div className="w-[30px] h-[30px] lg:w-[30px] lg:h-[30px]">
                {item.type === 'success' ? (
                  <Lottie animationData={lightDarkMode ? SuccessLightIcon : SuccessIcon} loop={true} />
                ) : (
                  <Lottie animationData={FailureIcon} loop={true} />
                )}
              </div>

              <div className={styles.title}>{item.title}</div>
            </div>
          </div>
        ))}
      </div>
    )
  )
}

export default AlertMobile
